export { default as Snakes } from './component'
